<template>
    <AppHeader />
    <div class="legal-page">
        <div class="legal-container">
            <h1>{{ $t('cookies.policy_title') }}</h1>

            <!-- DEFINICIÓN Y FUNCIÓN GENÉRICA -->
            <section class="legal-section">
                <h2>{{ $t('cookies.definition_title') }}</h2>
                <p>{{ $t('cookies.definition_text') }}</p>
                <p>{{ $t('cookies.definition_text2') }}</p>
                <p>{{ $t('cookies.definition_text3') }}</p>
                <p>{{ $t('cookies.definition_text4') }}</p>
            </section>

            <!-- COOKIES UTILIZADAS -->
            <section class="legal-section">
                <h2>{{ $t('cookies.cookies_used_title') }}</h2>

                <!-- Cookies necesarias -->
                <h3>{{ $t('cookies.necessary') }}</h3>
                <p>{{ $t('cookies.necessary_text_new') }}</p>
                <table class="cookies-table">
                    <thead>
                        <tr>
                            <th>{{ $t('cookies.table.name') }}</th>
                            <th>{{ $t('cookies.table.provider') }}</th>
                            <th>{{ $t('cookies.table.purpose') }}</th>
                            <th>{{ $t('cookies.table.expiry') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>cookie-agreed</td>
                            <td>{{ $t('cookies.provider_internal') }}</td>
                            <td>{{ $t('cookies.necessary_purpose') }}</td>
                            <td>{{ $t('cookies.duration_1year') }}</td>
                        </tr>
                        <tr>
                            <td>PHPSESSID</td>
                            <td>{{ $t('cookies.provider_internal') }}</td>
                            <td>{{ $t('cookies.session_purpose') }}</td>
                            <td>{{ $t('cookies.duration_session') }}</td>
                        </tr>
                    </tbody>
                </table>

                <!-- Cookies de preferencias -->
                <h3>{{ $t('cookies.preferences') }}</h3>
                <p>{{ $t('cookies.preferences_text_new') }}</p>
                <table class="cookies-table">
                    <thead>
                        <tr>
                            <th>{{ $t('cookies.table.name') }}</th>
                            <th>{{ $t('cookies.table.provider') }}</th>
                            <th>{{ $t('cookies.table.purpose') }}</th>
                            <th>{{ $t('cookies.table.expiry') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>PHPSESSID</td>
                            <td>{{ $t('cookies.provider_internal') }}</td>
                            <td>{{ $t('cookies.preferences_purpose') }}</td>
                            <td>{{ $t('cookies.duration_session') }}</td>
                        </tr>
                    </tbody>
                </table>

                <!-- Cookies de estadísticas -->
                <h3>{{ $t('cookies.statistics') }}</h3>
                <p>{{ $t('cookies.statistics_text_new') }}</p>
                <p class="opt-out-text">
                    {{ $t('cookies.ga_optout_text') }}
                    <a href="https://tools.google.com/dlpage/gaoptout?hl=es" target="_blank">
                        {{ $t('cookies.ga_optout_link') }}
                    </a>
                </p>
                <table class="cookies-table">
                    <thead>
                        <tr>
                            <th>{{ $t('cookies.table.name') }}</th>
                            <th>{{ $t('cookies.table.provider') }}</th>
                            <th>{{ $t('cookies.table.purpose') }}</th>
                            <th>{{ $t('cookies.table.expiry') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>_ga</td>
                            <td>Google Analytics</td>
                            <td>{{ $t('cookies.ga_purpose') }}</td>
                            <td>{{ $t('cookies.duration_2years') }}</td>
                        </tr>
                        <tr>
                            <td>_gid</td>
                            <td>Google Analytics</td>
                            <td>{{ $t('cookies.gid_purpose') }}</td>
                            <td>{{ $t('cookies.duration_24hours') }}</td>
                        </tr>
                        <tr>
                            <td>_gat</td>
                            <td>Google Analytics</td>
                            <td>{{ $t('cookies.gat_purpose') }}</td>
                            <td>{{ $t('cookies.duration_1minute') }}</td>
                        </tr>
                    </tbody>
                </table>

                <!-- Cookies de Marketing -->
                <h3>{{ $t('cookies.marketing') }}</h3>
                <p>{{ $t('cookies.marketing_text_new') }}</p>
                <table class="cookies-table">
                    <thead>
                        <tr>
                            <th>{{ $t('cookies.table.name') }}</th>
                            <th>{{ $t('cookies.table.provider') }}</th>
                            <th>{{ $t('cookies.table.purpose') }}</th>
                            <th>{{ $t('cookies.table.expiry') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>fbp</td>
                            <td>Facebook (Meta)</td>
                            <td>{{ $t('cookies.fbp_purpose') }}</td>
                            <td>{{ $t('cookies.duration_3months') }}</td>
                        </tr>
                    </tbody>
                </table>
            </section>

            <!-- CÓMO HABILITAR/DESHABILITAR COOKIES -->
            <section class="legal-section">
                <h2>{{ $t('cookies.how_to_title') }}</h2>
                <p>{{ $t('cookies.how_to_text') }}</p>
                <ul class="browser-list">
                    <li>
                        <strong>Internet Explorer:</strong> 
                        {{ $t('cookies.ie_instructions') }}
                        <a href="http://windows.microsoft.com/es-ES/windows/support" target="_blank">{{ $t('cookies.ie_link') }}</a>
                    </li>
                    <li>
                        <strong>Firefox:</strong> 
                        {{ $t('cookies.firefox_instructions') }}
                        <a href="http://support.mozilla.org/es/home" target="_blank">{{ $t('cookies.firefox_link') }}</a>
                    </li>
                    <li>
                        <strong>Chrome:</strong> 
                        {{ $t('cookies.chrome_instructions') }}
                        <a href="http://support.google.com/chrome/?hl=es" target="_blank">{{ $t('cookies.chrome_link') }}</a>
                    </li>
                    <li>
                        <strong>Safari:</strong> 
                        {{ $t('cookies.safari_instructions') }}
                        <a href="http://www.apple.com/es/support/safari/" target="_blank">{{ $t('cookies.safari_link') }}</a>
                    </li>
                </ul>
                <div class="cookie-warning">
                    <h4>{{ $t('cookies.what_happens_title') }}</h4>
                    <p>{{ $t('cookies.what_happens_text') }}</p>
                </div>
            </section>

            <!-- Footer -->
            <!--<div class="legal-footer">
                <p>© 2026 INTEGRALIA CODE SOLUTIONS, S.L. - Todos los derechos reservados.</p>
                <p class="legal-footer-links">
                    <router-link :to="{ name: 'aviso-legal', params: { lang: currentLang } }">Aviso Legal</router-link> |
                    <router-link :to="{ name: 'politica-privacidad', params: { lang: currentLang } }">Política de Privacidad</router-link> |
                    <router-link :to="{ name: 'politica-cookies', params: { lang: currentLang } }">Política de Cookies</router-link>
                </p>
            </div>-->
        </div>
    </div>
    <AppFooter />
    <WhatsAppFloat />
</template>

<script>
import AppHeader from '@/components/layout/Header.vue'
import AppFooter from '@/components/layout/Footer.vue'
import WhatsAppFloat from '@/components/common/WhatsAppFloat.vue'
export default {
    name: 'PoliticaCookies',
    components: {
        AppHeader,
        AppFooter,
        WhatsAppFloat
    },
    computed: {
        currentLang() {
            return this.$route.params.lang || 'es'
        }
    }
}
</script>

<style scoped>
.legal-page {
    max-width: 900px;
    margin: 0 auto;
    padding: 40px 20px;
    background: #fff;
    font-family: 'Open Sans', Arial, sans-serif;
    color: #333;
}

.legal-container h1 {
    color: #1C4A8D;
    font-size: 2rem;
    border-bottom: 3px solid #1C4A8D;
    padding-bottom: 15px;
    margin-bottom: 30px;
}

.legal-section {
    margin-bottom: 35px;
}

.legal-section h2 {
    color: #1C4A8D;
    font-size: 1.4rem;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e9ecef;
}

.legal-section h3 {
    color: #2c3e50;
    font-size: 1.1rem;
    margin-top: 25px;
    margin-bottom: 10px;
}

.legal-section p {
    line-height: 1.7;
    margin-bottom: 12px;
}

.legal-section ul {
    list-style: none;
    padding-left: 0;
}

.legal-section ul li {
    padding: 6px 0;
    line-height: 1.6;
    border-bottom: 1px solid #f0f0f0;
}

.legal-section ul li:last-child {
    border-bottom: none;
}

.legal-section a {
    color: #1C4A8D;
    text-decoration: none;
}

.legal-section a:hover {
    text-decoration: underline;
}

/* Tabla de cookies */
.cookies-table {
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0 20px 0;
    font-size: 0.85rem;
}

.cookies-table th {
    background: #1C4A8D;
    color: white;
    padding: 10px 12px;
    text-align: left;
}

.cookies-table td {
    padding: 10px 12px;
    border-bottom: 1px solid #e9ecef;
    vertical-align: top;
}

.cookies-table tr:nth-child(even) {
    background: #f8f9fa;
}

.opt-out-text {
    padding: 12px 15px;
    background: #fff3cd;
    border-radius: 6px;
    font-size: 0.9rem;
    margin: 10px 0 15px 0;
}

.opt-out-text a {
    font-weight: 600;
}

.browser-list {
    list-style: none;
    padding: 0;
    margin: 10px 0;
}

.browser-list li {
    padding: 8px 12px;
    font-size: 0.9rem;
    border-bottom: 1px solid #f0f0f0;
    background: #fafafa;
}

.browser-list li:last-child {
    border-bottom: none;
}

.browser-list a {
    font-weight: 500;
}

.cookie-warning {
    margin-top: 20px;
    padding: 15px 20px;
    background: #fce8e6;
    border-radius: 8px;
    border-left: 4px solid #d93025;
}

.cookie-warning h4 {
    color: #d93025;
    margin: 0 0 5px 0;
}

.cookie-warning p {
    margin: 0;
    font-size: 0.9rem;
}

/* Footer legal */
.legal-footer {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 2px solid #e9ecef;
    text-align: center;
    font-size: 0.85rem;
    color: #6c757d;
}

.legal-footer-links {
    margin-top: 10px;
}

.legal-footer-links a {
    color: #1C4A8D;
    text-decoration: none;
    margin: 0 8px;
}

.legal-footer-links a:hover {
    text-decoration: underline;
}

/* Responsive */
@media (max-width: 768px) {
    .legal-page {
        padding: 20px 15px;
    }
    .legal-container h1 {
        font-size: 1.5rem;
    }
    .legal-section h2 {
        font-size: 1.2rem;
    }
    .cookies-table {
        font-size: 0.75rem;
    }
    .cookies-table th,
    .cookies-table td {
        padding: 6px 8px;
    }
}
</style>